/*
 * Copyright (C) 2009-2025 SonarSource Sàrl
 * All rights reserved
 * mailto:info AT sonarsource DOT com
 */

import { useIntl } from 'react-intl';
import { PullRequest } from '~shared/types/branch-like';
import { MeasureEnhanced } from '~shared/types/measures';
import { MetricKey, MetricType } from '~shared/types/metrics';
import { getLeakValue } from '~sq-server-commons/components/measure/utils';
import { findMeasure } from '~sq-server-commons/helpers/measures';
import { formatMeasure } from '~sq-server-commons/sonar-aligned/helpers/measures';
import CurrentBranchLikeMergeInformation from '../../nav/component/branch-like/CurrentBranchLikeMergeInformation';

interface Props {
  measures: MeasureEnhanced[];
  pullRequest: PullRequest;
}

export default function PullRequestMetaTopBar({ pullRequest, measures }: Readonly<Props>) {
  const intl = useIntl();

  const leftSection = (
    <div>
      <strong className="sw-typo-semibold sw-mr-1">
        {formatMeasure(
          getLeakValue(findMeasure(measures, MetricKey.new_lines)),
          MetricType.ShortInteger,
        ) || '0'}
      </strong>
      {intl.formatMessage({ id: 'metric.new_lines.name' })}
    </div>
  );
  const rightSection = (
    <div className="sw-flex sw-items-center sw-gap-2">
      <CurrentBranchLikeMergeInformation pullRequest={pullRequest} />
    </div>
  );

  return (
    <div className="sw-flex sw-justify-between sw-whitespace-nowrap sw-typo-default">
      {leftSection}
      {rightSection}
    </div>
  );
}
